import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LoginRequest, LoginResponse} from '../models/auth';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';
import {HttpErrorResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/internal/operators';
import {ApolloQueryResult} from 'apollo-client';
import {throwError} from 'rxjs/index';

@Injectable()
export class AuthService {

  constructor(private apollo: Apollo) {
  }

  login({email, password}: LoginRequest): Observable<LoginResponse> {
    const mutation = gql`
      mutation m($email: String!, $password: String!) {
        login(email: $email, password: $password) {
          accessToken
          id
          email
          firstName
          lastName
          dobYear
          dobMonth
          dobDay
          gender
        }
      }
    `;

    return this.apollo.use('unprotected').mutate({
      mutation,
      variables: {
        email,
        password
      }
    }).pipe(
      map((response: ApolloQueryResult<{ login: LoginResponse }>) =>
        response.data.login),
      catchError((error: HttpErrorResponse) => throwError(error))
    );
  }
}
